import { Summary, List, CadresSummary, TradeSummary } from "../Components/index.js";

export default [
    {
        path: "/report/plan-leave/list",
        component: List,
        name: "report-plan-leave-list",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/plan-leave/summary",
        component: Summary,
        name: "report-plan-leave-summary",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/plan-leave/cadre-summary",
        component: CadresSummary,
        name: "report-plan-leave-cadre-summary",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/plan-leave/trade-summary",
        component: TradeSummary,
        name: "report-plan-leave-trade-summary",
        meta: {
            requiresAuth: true,
        },
    },
];
